import { render } from "./addVoucher.vue?vue&type=template&id=06e8632a&scoped=true"
import script from "./addVoucher.vue?vue&type=script&lang=js"
export * from "./addVoucher.vue?vue&type=script&lang=js"

import "./addVoucher.vue?vue&type=style&index=0&id=06e8632a&lang=scss&scoped=true"
import "./addVoucher.vue?vue&type=style&index=1&id=06e8632a&lang=css"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06e8632a"]])

export default __exports__